import type {NodeClassImpl} from "#template/runtime-graph/types"
import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"
import type {MaterialGraph} from "@cm/material-nodes"
import type {ISceneManager} from "#template/interfaces/scene-manager"
import type {Subscription} from "rxjs"
import {defer, map} from "rxjs"

const TD = TypeDescriptors

const flattenMaterialDescriptor = {
    sceneManager: TD.inlet(TD.Identity<ISceneManager>()),
    input: TD.inlet(TD.MaterialGraph),
    output: TD.outlet(TD.MaterialGraph),
}

export class FlattenMaterial implements NodeClassImpl<typeof flattenMaterialDescriptor, typeof FlattenMaterial> {
    static descriptor = flattenMaterialDescriptor
    static uniqueName = "FlattenMaterial"
    sceneManager!: Inlet<ISceneManager>
    input!: Inlet<MaterialGraph>
    output!: Outlet<MaterialGraph>

    private pending: Subscription | null = null

    run() {
        this.cleanup()

        if (this.sceneManager === NotReady || this.input === NotReady) {
            this.output.emitIfChanged(NotReady)
            return
        }

        const {sceneManager, input} = this

        this.pending = this.sceneManager.addTask({
            description: `flattenMaterial(${this.input.uniqueId})`,
            task: defer(() => input.flatten(sceneManager.getResolver())).pipe(
                map((materialGraph) => {
                    this.output.emitIfChanged(materialGraph)
                }),
            ),
            critical: true,
        })
    }

    cleanup() {
        this.pending?.unsubscribe()
        this.pending = null
    }
}
